import './styles/quasar.sass'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import langES from 'quasar/lang/es.js'

export default {
  plugins: [],

  config: {
    brand: {
      primary: '#19B2A3',
      secondary: '#004646',
      info: '#5887F9',
      negative: '#F15A24'
    }
  },

  extras: [
    'material-icons',
    'material-icons-outlined'
  ],

  framework: {
    lang: langES,
    cssAddon: true
  }
}
